import React from "react";
import BasePage from "./BasePage";
import { useApp } from "./App";

function PageNotFound() {
  const {
    client,
  } = useApp();

  return (
    <BasePage>
      <div>
        {client && client.public_data?.logo_url && <a href="/">
          <img
            src={client.public_data.logo_url}
            alt={client.name}
            className="mx-auto"
            style={{ width: 200 }}
          />
        </a>}
        <div className="text-center">
          <div className="px-4">
            <h1 className="text-3xl font-bold">
              Tattoo Consent and Release Form
            </h1>
            <p className="text-xl mt-4 mb-4">
              <span className="font-bold">404</span> - Page not found
            </p>
            <p className="text-lg mb-8">
              <a href="/" className="underline">
                Go back to the home page
              </a>
            </p>
          </div>
        </div>
      </div>
    </BasePage>
  );
}

export default PageNotFound;
